import { render, staticRenderFns } from "./GenerateAccessToken.vue?vue&type=template&id=555827c8&scoped=true"
import script from "./GenerateAccessToken.vue?vue&type=script&lang=js"
export * from "./GenerateAccessToken.vue?vue&type=script&lang=js"
import style0 from "./GenerateAccessToken.vue?vue&type=style&index=0&id=555827c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555827c8",
  null
  
)

export default component.exports